import { useMemo } from 'react';
import apiClient from 'src/api/axiosClient';
import {
  ForgotPasswordParams,
  LoginParams,
  LoginResponse,
  SetPasswordParams,
} from '../types';

export function useAuthenticationApi() {
  return useMemo(
    () => ({
      login: (params: LoginParams) => {
        return apiClient.post<LoginResponse>(`/auth/token`, params);
      },

      forgotPassword: (params: ForgotPasswordParams) => {
        return apiClient.post(`/auth/forgot-password`, params);
      },

      setPassword: (params: SetPasswordParams) => {
        return apiClient.put(`/auth/set-password`, params);
      },
    }),
    [],
  );
}
